import axios from 'axios';

const BASE_URL_SUFFIX = 'v1';

const shareLinkApi = axios.create({
  baseURL: `${process.env.NEXT_PUBLIC_SHARE_LINK_API}/${BASE_URL_SUFFIX}`,
});

shareLinkApi.interceptors.request.use((req) => {
  const accessToken = process.env.NEXT_PUBLIC_SHARE_LINK_API_KEY;

  if (accessToken) {
    req.headers['X-AUTH-TOKEN'] = `${accessToken}`;
  } else {
    delete req.headers['X-AUTH-TOKEN'];
  }
  return req;
});

export default shareLinkApi;
